import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

// GK 2026-04-23 This ensures that the domain you are reaching is legitimate.
// This was written due to that person who copied my site. 
const DomainGatekeeper = ({ children }) => {
  const hostname = window.location.hostname.toLowerCase();
  const isAllowed =
    hostname === 'localhost' ||
    hostname === 'punkypay.com' ||
    hostname.endsWith('.punkypay.com');

  useEffect(() => {
    console.log("Hostname:", hostname);
    console.log("isAllowed:", isAllowed);
    if (!isAllowed) {
        window.location.replace('https://punkypay.com');
    }
  }, [isAllowed, hostname]);

  if (!isAllowed) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
          {/* <link rel="canonical" href="https://punkypay.com/" /> */}
        </Helmet>
        <p>Redirecting to the official Punkypay site…</p>
      </>
    );
  }

  return children || <p>Loading...</p>;
};

export default DomainGatekeeper;
